import { WrapperTable } from '../components'
import TabPermisoPorEtapa from './TabPermisoPorEtapa'
import RUTAS from 'src/pages/admin/router/routes'

function ConfigEtapaGrupoPermiso() {
    return (
        <WrapperTable goBackTo={`/${RUTAS.ADMIN_MASTER}`}>
            <TabPermisoPorEtapa />
        </WrapperTable>
    )
}

export default ConfigEtapaGrupoPermiso
